import MapControlPopover from '../MapControlPopover';

import ReticleIcon from 'components/icons/ReticleIcon';
import TouchIcon from 'components/icons/TouchIcon';

import useTranslation from './hooks/useTranslation';

import { DISPLAY_ICON_TEST_ID, LABEL_ICON_TEST_ID, POINT_MODE, TEST_ID } from './constants';
import type { PointModeIcons, PointModeLabels, Props } from './types';

const POINT_MODE_ICON: PointModeIcons = {
    [POINT_MODE.RETICLE]: ReticleIcon,
    [POINT_MODE.TOUCH]: TouchIcon
};

const PointModeDropdown = ({ onPointModeChange, pointMode, testId = TEST_ID }: Props) => {
    const { RETICLE, TOUCH } = useTranslation();

    const Icon = POINT_MODE_ICON[pointMode];

    const pointModeLabels: PointModeLabels = {
        [POINT_MODE.RETICLE]: RETICLE,
        [POINT_MODE.TOUCH]: TOUCH
    };

    const options = [
        { label: RETICLE, value: POINT_MODE.RETICLE },
        { label: TOUCH, value: POINT_MODE.TOUCH }
    ];

    return (
        <MapControlPopover
            displayText={
                <>
                    <Icon testId={LABEL_ICON_TEST_ID} />

                    {pointModeLabels[pointMode]}
                </>
            }
            displayIcon={<Icon testId={DISPLAY_ICON_TEST_ID} />}
            onChange={onPointModeChange}
            options={options}
            testId={testId}
            value={pointMode}
        />
    );
};

export default PointModeDropdown;
